import {
  AfterContentInit,
  Directive,
  ElementRef,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Directive({
  selector: '[apAutoFocus]',
})
export class ApAutofocusDirective implements AfterContentInit {
  @Input() apAutoFocusIgnoreFocus?: boolean;
  @Input() apAutoFocusDelay?: number;
  @Output() apAutoFocusComplete: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  public constructor(private el: ElementRef) {}

  public ngAfterContentInit() {
    if (this.apAutoFocusIgnoreFocus) {
      return;
    }

    setTimeout(
      () => {
        this.el.nativeElement.focus();
        this.apAutoFocusComplete.next(true);
        setTimeout(() => { this.el.nativeElement.select(); }, 50);
      },
      this.apAutoFocusDelay === undefined ? 500 : this.apAutoFocusDelay,
    );
  }
}
